import { createProvider } from '@nvision/services/data-provider';

import type { LinkPricingParams } from '../../models';
import { logger } from '../../utils/logger';
import * as api from './api';
import { normalizeCreateContractPricing } from './normalize';

export const createContractPricing = createProvider(
  (params: LinkPricingParams, options: { signal?: AbortController['signal'] } = {}) =>
    api.createContractPricing(normalizeCreateContractPricing(params), options),
)
  .andThen((res) => res)
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      logger.warn('Create contract pricing is aborted');
    } else {
      logger.error(`Create contract pricing was failed: ${error}`);
    }
    throw error;
  });
